import request from './request'
import Qs from 'qs';


// 联系我们
export function contact(query) {
  return request({
    url: '/site/contact',
    method: 'get',
    params: query
  })
}

//code 换取token
export function user(query) {
  return request({
    url: '/user/get-token/?code='+query,
    method: 'get',
    // params: query
  })
}

//个人信息
export function info() {
  return request({
    url: 'member/default/info',
    method: 'get',
    // params: query
  })
}

// 留言
export function feedback(query) {
  return request({
    url: '/member/default/feedback',
    method: 'post',
    // headers:{Authorization:'Bearer '+sessionStorage.getItem('id')},
    data: Qs.stringify(query)
  })
}

//发送验证码
export function SendCode(query) {
  return request({
    url: '/site/sendsms',
    method: 'post',
    data: Qs.stringify(query)
  })
}

//会员注册
export function UpdateInfo(query) {
  return request({
    url: '/member/default/update-info',
    method: 'post',
    data: Qs.stringify(query)
  })
}

//添加车牌号
export function AddPlatecode(query) {
  return request({
    url: '/member/parking/add-platecode',
    method: 'post',
    data: Qs.stringify(query)
  })
}

//解绑车牌号
export function removePlatecode(query) {
  return request({
    url: '/member/parking/remove-platecode',
    method: 'post',
    data: Qs.stringify(query)
  })
}

//我的车牌号
export function MyPlatecode(query) {
  return request({
    url: '/member/parking/my-platecode',
    method: 'get',
    params: query
  })
}

//获取停车信息
export function platecode(query) {
  return request({
    url: '/member/parking/info',
    method: 'get',
    params: query
  })
}

//订车订单记录
export function carRecord(query) {
  return request({
    url: '/member/parking/order',
    method: 'get',
    params: query
  })
}

//海报
export function poster(query) {
  return request({
    url: '/site/poster',
    method: 'get',
    params: query
  })
}

//活动列表
export function activity(query) {
  return request({
    url: '/activity/index',
    method: 'get',
    params: query
  })
}


//活动列表详情
export function view(query) {
  return request({
    url: '/activity/view',
    method: 'get',
    params: query
  })
}

//活动报名
export function signName(query) {
  return request({
    url: '/member/activity/sign',
    method: 'get',
    params: query
  })
}

//已报名的活动展示
export function SignList(query) {
  return request({
    url: '/member/activity/sign-list',
    method: 'get',
    params: query
  })
}

//瑜伽课程列表
export function yoga(query) {
  return request({
    url: '/yoga/index',
    method: 'get',
    params: query
  })
}

//瑜伽课程列表详情
export function yogaDetails(query) {
  return request({
    url: '/yoga/view',
    method: 'get',
    params: query
  })
}

// 优惠券！！！！！！！！！！！！！！！！！！！！！！！
// 可领取优惠券
export function Getcoupon(query) {
  return request({
    url: '/member/coupon/index',
    method: 'get',
    params: query
  })
}

// 我的优惠券
export function Mycoupon(query) {
  return request({
    url: '/member/coupon/my',
    method: 'get',
    params: query
  })
}

// 立即领取优惠券
export function receive(query) {
  return request({
    url: '/member/coupon/receive',
    method: 'get',
    params: query
  })
}

// 积分兑换商城列表
export function product(query) {
  return request({
    url: '/product/index',
    method: 'get',
    params: query
  })
}

// 积分变更记录
export function IntegralChange(query) {
  return request({
    url: '/member/default/integral-log',
    method: 'get',
    params: query
  })
}

// 积分兑换商城详情
export function productDetails(query) {
  return request({
    url: '/product/view',
    method: 'get',
    params: query
  })
}

// 积分兑换商城下单
export function order(params,query) {
  return request({
    url: '/member/corder/create?product_id='+query,
    method: 'post',
    data:  Qs.stringify(params)
  })
}

// 兑换订单记录
export function corder(query) {
  return request({
    url: '/member/corder/index',
    method: 'get',
    params: query
  })
}

// 商品是否已领取记录
export function Whether(query) {
  return request({
    url: '/member/corder/view',
    method: 'get',
    params: query
  })
}

// 上传图片
export function Uploads(query) {
  return request({
    url: '/upload/image',
    method: 'post',
    data:  query
  })
}

// 上传小票
export function Upload_Bill(query) {
  return request({
    url: '/member/parking/upload-bill',
    method: 'post',
    data:  Qs.stringify(query)
  })
}

// 租赁信息
export function rentinfo(query) {
  return request({
    url: '/site/rentinfo',
    method: 'get',
    params:  query
  })
}

// 快闪店
export function company(query) {
  return request({
    url: '/company/index',
    method: 'get',
    params:  query
  })
}

// 快闪店楼层和行业分类
export function category(query) {
  return request({
    url: '/company/category',
    method: 'get',
    params:  query
  })
}

// 快闪店详情
export function company_Details(query) {
  return request({
    url: '/company/view',
    method: 'get',
    params:  query
  })
}

//楼宇介绍
export function readMe(query) {
  return request({
    url: '/site/page',
    method: 'get',
    params:  query
  })
}

//订单支付
export function wechat(query) {
  return request({
    url: '/pay/wechat',
    method: 'get',
    params:  query
  })
}


// WEBPACK FOOTER //
// ./src/api/profile.js